import { render, staticRenderFns } from "./ScopeList.vue?vue&type=template&id=6de0a443&"
import script from "./ScopeList.vue?vue&type=script&lang=js&"
export * from "./ScopeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports